<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
			destroy-on-close>
			<template #default>
				<vxe-grid v-if="list_gridOptions" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	export default {
		mixins: [listMixins,modalMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			}
		},
		
		data() {
			return {
				modal_title: '冲红详情',
				modal_width:1000,
				modal_height:600,
				modal_model:false,
				list_formConfig: [{
						field: 'a',
						title: 'A',
						itemRender: {
							name: '$input'
						}
					}
				],
				list_columns: [
					{
						type: 'seq',
						title: '#',
						width:50,
						fixed:'left'
					},
					{
						field: 'invoicenumber',
						title: '蓝票发票号码',

					},
					{
						field: 'invoiceamount',
						title: '价税合计',

					},
					{
						field: 'reason',
						title: '冲红原因',

					},
					{
						field: 'redtype',
						title: '红冲类型',

					},
					{
						field: 'redamount',
						title: '红冲总金额',

					},
					{
						field: 'discountnradio',
						title: '折让率',

					},
					// {
					// 	title: '操作',
					// 	fixed: "right",
					// 	align: 'center',
					// 	width: 65,
					// 	slots: {
					// 		default: ({row}) => {
					// 			return [<el-button type = "text" size = "mini" onClick = {() => {this.ddcode(row)}}>凭证</el-button>]
					// 		}
					// 	}
					// }					
				],
				list_footerField:[
					{field:'invoiceamount',toFixed:2},
				]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			list_beforeCreateGrid(gridOptions){
				gridOptions.formConfig = false
			},
			list() {
				return new Promise((resolve) => {
					let ids = this.data.map((item)=>{
						return item.id
					})
					this.$api.universalinvoice.getuploaddetail({
						ids:ids,
						type:'red',
					}).then((res)=>{
						resolve({
							list: res
						})
					},()=>{
						resolve({
							list: []
						})
					})
				})
			},
			submit() {
				this.$emit('submit',{data:this.data})
				this.modal_cancel()
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {
			
		}
	}
</script>